import { BaseTransport, LogParams } from './base';

type ConsoleMethod = 'log' | 'info' | 'warn' | 'error' | 'debug' | 'trace';

export class ConsoleTransport extends BaseTransport {
    public downloadLogs(): Promise<void> {
        return Promise.resolve();
    }
    constructor() {
        super();
    }
    public log({ level, messageParts }: LogParams): void {
        //@ts-ignore
        const consoleLevel: any = console[level] ? level : 'log';
        console[consoleLevel as ConsoleMethod](...messageParts);
    }
}
